import React, { useState } from "react";
import { X } from "react-feather";
import { Modal } from "react-bootstrap";

const DetailModal = ({ selectedDetailModal, setSelectedDetailModal }) => {
  const [detailModalView, setDetailModalView] = useState("market_share");

  const detailedCompetitiveData = {
    // TECHNOLOGIES
    "tech-0": {
      name: "LV/MV Switchgear & Busway",
      type: "Technology",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "38%",
          revenue: "~22% of Schneider Electric revenue",
          focus: "Integrated LV/MV gear, APC busway, spec control in AI builds",
          details:
            "Global leader with Square D/APC density and 36% NA mix; dominates AI/data center specs with bundled UPS/racks/busway.",
        },
        {
          name: "nVent",
          position: "Strong",
          marketShare: "24%",
          revenue: "~16% of nVent revenue",
          focus: "E+I busway, fast-ship modular tracks, NA/EU contractors",
          details:
            "Competitive in busway with E+I acquisition; leverages speed-to-serve in NA and modular track solutions for AI halls.",
        },
      ],
      keyTakeaways:
        "LV/MV switchgear & busway is a $73.5B market (MarketsandMarkets) growing 6.3% CAGR. Schneider leads at 38% share via integrated power stacks; nVent holds a strong #2 with 24% and fast-ship busway. Competitive intensity is high—spec-led red ocean. nVent must protect busway pull-through while avoiding price wars.",
    },
    "tech-1": {
      name: "EMI/Shielding & Thermal Materials",
      type: "Technology",
      companies: [
        {
          name: "Boyd Corporation",
          position: "Leader",
          marketShare: "46%",
          revenue: "~28% of Boyd revenue",
          focus: "EMI gaskets, absorbers, TIMs for auto/compute/5G",
          details:
            "Dominant materials player with 3M Preferred Converter status and broad EMI/TIM catalog across NA/EU/APAC.",
        },
        {
          name: "nVent",
          position: "Limited",
          marketShare: "8%",
          revenue: "~3% of nVent revenue",
          focus: "Grounding/earthing, selective EMI kits for enclosures",
          details:
            "Participates via enclosure grounding and selective shielding kits; not a core focus versus Boyd.",
        },
        {
          name: "Schneider Electric",
          position: "Limited",
          marketShare: "6%",
          revenue: "~2% of Schneider Electric revenue",
          focus: "Panel/switchgear shielding, partnering with converters",
          details:
            "Uses third-party converters; internal focus remains on power gear rather than materials.",
        },
      ],
      keyTakeaways:
        "EMI/Shielding & thermal materials is a $7.7B market (MarketsandMarkets) at 6.8% CAGR—fragmented but Boyd leads with ~46%. nVent and Schneider are niche participants. Competitive intensity is moderate; partnering vs. direct compete is optimal for nVent.",
    },
    "tech-2": {
      name: "Electrical Enclosures",
      type: "Technology",
      companies: [
        {
          name: "nVent",
          position: "Leader",
          marketShare: "32%",
          revenue: "~28% of nVent revenue",
          focus: "HOFFMAN/Schroff industrial, data center racks, hazardous areas",
          details:
            "Category crown jewel for nVent with deep channel and certification breadth; fast-ship SLAs drive share.",
        },
        {
          name: "Schneider Electric",
          position: "Strong",
          marketShare: "24%",
          revenue: "~10% of Schneider Electric revenue",
          focus: "APC/NetShelter racks, Square D panels, integrated power",
          details:
            "Strong #2 leveraging Square D/APC and EcoStruxure integration in buildings and data centers.",
        },
        {
          name: "Boyd Corporation",
          position: "Limited",
          marketShare: "4%",
          revenue: "~3% of Boyd revenue",
          focus: "Thermal chassis, specialty enclosures for A&D/semis",
          details:
            "Selective rugged/thermal enclosures; not scaled in general-purpose electrical enclosures.",
        },
      ],
      keyTakeaways:
        "Electrical enclosures are a $7.4B market (MarketsandMarkets) growing 5.6% CAGR. nVent leads with 32% share and 28% of its revenue—DEFEND AT ALL COSTS. Schneider is strong at 24% via APC racks; Boyd plays niche. Crowded but nVent holds the advantage with speed and certifications.",
    },
    "tech-3": {
      name: "Data Center Liquid Cooling",
      type: "Technology",
      companies: [
        {
          name: "Boyd Corporation",
          position: "Leader",
          marketShare: "32%",
          revenue: "~48% of Boyd revenue",
          focus: "2MW CDUs, cold plates, loops; hyperscaler deployments",
          details:
            "5M cold plates shipped and multi-MW CDUs; deep hyperscaler incumbency and Vietnam/Poland scale.",
        },
        {
          name: "Schneider Electric",
          position: "Strong",
          marketShare: "24%",
          revenue: "~6% of Schneider Electric revenue",
          focus: "Motivair-based CDUs, integrated racks/UPS with EcoStruxure",
          details:
            "Integrates liquid cooling with power stack; NVIDIA-aligned reference designs accelerate spec lock.",
        },
        {
          name: "nVent",
          position: "Growing",
          marketShare: "18%",
          revenue: "~8% of nVent revenue",
          focus: "Rack/row CDUs, manifolds, integration with busway/enclosures",
          details:
            "New portfolio scaling; leverages enclosure/power adjacencies to win AI rows with fast-ship CDUs.",
        },
      ],
      keyTakeaways:
        "Data center liquid cooling is a $4.8B market (MarketsandMarkets) surging at 24.7% CAGR. Boyd leads (32%) on cold plates/CDUs; Schneider close second via Motivair; nVent is a fast follower. This is a high-growth battleground—nVent must scale capacity and integrations to capture AI spend.",
    },
    "tech-4": {
      name: "Industrial Heat-Tracing",
      type: "Technology",
      companies: [
        {
          name: "nVent",
          position: "Leader",
          marketShare: "54%",
          revenue: "~14% of nVent revenue",
          focus: "RAYCHEM heat-trace for energy, LNG, utilities; services",
          details:
            "Clear leader with Raychem brand, lifecycle services, and digital monitoring in harsh environments.",
        },
        {
          name: "Schneider Electric",
          position: "Moderate",
          marketShare: "12%",
          revenue: "~3% of Schneider Electric revenue",
          focus: "Bundle with grid/utility projects; partner-delivered",
          details:
            "Participates via project bundling; relies on partners for trace specialty.",
        },
      ],
      keyTakeaways:
        "Industrial heat-tracing is a $3.4B market (MarketsandMarkets) at 5.2% CAGR. nVent dominates at 54% share—DEFEND AT ALL COSTS. Schneider is a minor participant. A protected profit pool with moderate growth and lower competitive intensity.",
    },

    // APPLICATIONS
    "app-0": {
      name: "Industry & Automation",
      type: "Application",
      companies: [
        {
          name: "Schneider Electric",
          position: "Strong",
          marketShare: "26%",
          revenue: "~18% of Schneider Electric revenue",
          focus: "PLC/drives + LV gear + enclosures; software-led pull-through",
          details:
            "Combines automation with power distribution; strong SI/channel ecosystem.",
        },
        {
          name: "nVent",
          position: "Growing",
          marketShare: "14%",
          revenue: "~18% of nVent revenue",
          focus: "Industrial enclosures, heat-trace, grounding",
          details:
            "Wins via certified enclosures/heat-trace in regulated plants; building OEM pull-through.",
        },
        {
          name: "Boyd Corporation",
          position: "Moderate",
          marketShare: "10%",
          revenue: "~12% of Boyd revenue",
          focus: "Thermal/EMI for drives, power modules",
          details:
            "Provides thermal assemblies and EMI for industrial electronics; niche but sticky.",
        },
      ],
      keyTakeaways:
        "Industry & Automation is a $276.6B market (MarketsandMarkets) growing 9.3% CAGR. Schneider is top tier at 26% share; nVent is growing from a strong enclosure/heat-trace base; Boyd plays component thermal/EMI. Large profit pool with moderate competitive intensity.",
    },
    "app-1": {
      name: "EV Charging Infrastructure",
      type: "Application",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "34%",
          revenue: "~8% of Schneider Electric revenue",
          focus: "EVlink chargers, MV/LV gear, microgrids",
          details:
            "Leads with integrated power + software + services; strong utility/municipal ties.",
        },
        {
          name: "nVent",
          position: "Strong",
          marketShare: "22%",
          revenue: "~8% of nVent revenue",
          focus: "Enclosures, busway, thermal protection for EVSE",
          details:
            "Supplies protective enclosures and busway; leverages fast-ship for depot rollouts.",
        },
        {
          name: "Boyd Corporation",
          position: "Limited",
          marketShare: "6%",
          revenue: "~5% of Boyd revenue",
          focus: "Thermal interfaces, seals for power electronics",
          details:
            "Supports EVSE electronics cooling and sealing; not a systems provider.",
        },
      ],
      keyTakeaways:
        "EV charging is a $121.9B market (MarketsandMarkets) at 21.5% CAGR. Schneider leads at 34% with full-stack power; nVent is strong via enclosures/thermal; Boyd niche in components. High-growth, spec-driven—nVent should co-bundle with power partners to gain share.",
    },
    "app-2": {
      name: "Grid Modernization & Utilities",
      type: "Application",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "36%",
          revenue: "~10% of Schneider Electric revenue",
          focus: "ADMS/DERMS + MV/LV gear, resilience projects",
          details:
            "Top microgrid/ADMS rankings; bundles software and MV gear to lock specs.",
        },
        {
          name: "nVent",
          position: "Moderate",
          marketShare: "12%",
          revenue: "~10% of nVent revenue",
          focus: "Heat-trace, enclosures, grounding for substations/pipelines",
          details:
            "Targets protection/heat-trace niches within utility projects; not lead spec holder.",
        },
      ],
      keyTakeaways:
        "Grid modernization is $103.4B (MarketsandMarkets) growing 10.5% CAGR. Schneider dominates at 36% via software + MV gear; nVent is a specialist in protection/heat-trace. Competitive intensity moderate; partnerships matter.",
    },
    "app-3": {
      name: "Commercial Buildings",
      type: "Application",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "30%",
          revenue: "~12% of Schneider Electric revenue",
          focus: "BMS + LV distribution + services",
          details:
            "Leverages EcoStruxure Building and Square D to win retrofit/efficiency mandates.",
        },
        {
          name: "nVent",
          position: "Growing",
          marketShare: "12%",
          revenue: "~18% of nVent revenue",
          focus: "Enclosures, busway, heat-trace in campuses/hospitals",
          details:
            "Wins on availability and certified enclosures; growing busway attach.",
        },
        {
          name: "Boyd Corporation",
          position: "Limited",
          marketShare: "4%",
          revenue: "~3% of Boyd revenue",
          focus: "Seals/EMI for building electronics and displays",
          details:
            "Component-level participation; not core to Boyd’s revenue.",
        },
      ],
      keyTakeaways:
        "Commercial buildings is a $101.7B market (MarketsandMarkets) at 13.4% CAGR. Schneider leads with integrated BMS/power; nVent grows via enclosures/busway; Boyd is niche. Large retrofit tailwinds; spec control is key.",
    },
    "app-4": {
      name: "Data Centers & Networks",
      type: "Application",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "28%",
          revenue: "~24% of Schneider Electric revenue",
          focus: "UPS/racks/busway + liquid cooling + DCIM",
          details:
            "Controls critical power stack; AI reference designs with NVIDIA accelerate wins.",
        },
        {
          name: "Boyd Corporation",
          position: "Strong",
          marketShare: "22%",
          revenue: "~35% of Boyd revenue",
          focus: "CDUs, cold plates, loops for AI racks",
          details:
            "Hyperscaler incumbent with multi-MW CDUs and cold-plate scale.",
        },
        {
          name: "nVent",
          position: "Strong",
          marketShare: "20%",
          revenue: "~22% of nVent revenue",
          focus: "Racks/enclosures, busway, emerging CDUs",
          details:
            "Competitive via E+I busway, Hoffman/Schroff racks, and new CDU portfolio; leverages speed-to-serve.",
        },
      ],
      keyTakeaways:
        "Data centers & networks is $41.1B (MarketsandMarkets) at 11.3% CAGR. Schneider leads at 28% with end-to-end power/cooling; Boyd strong on liquid cooling; nVent strong on racks/busway/CDUs. Crowded, high-growth battlefield driven by AI—nVent must integrate and move fast.",
    },

    // GEOGRAPHIES
    "geo-0": {
      name: "Asia Pacific",
      type: "Geography",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "32%",
          revenue: "~27% of Schneider Electric revenue",
          focus: "China/India manufacturing hubs; AI factories; grid",
          details:
            "Extensive footprint and software-led offers; strong in LV/MV and data centers.",
        },
        {
          name: "Boyd Corporation",
          position: "Strong",
          marketShare: "18%",
          revenue: "~35% of Boyd revenue",
          focus: "Vietnam/China volume for CDUs/cold plates; electronics",
          details:
            "APAC cost/scale base underpins hyperscaler and electronics programs.",
        },
        {
          name: "nVent",
          position: "Growing",
          marketShare: "12%",
          revenue: "~15% of nVent revenue",
          focus: "Expanding enclosures/heat-trace; select data center builds",
          details:
            "Building APAC presence; opportunity to grow with local fast-ship nodes.",
        },
      ],
      keyTakeaways:
        "APAC is a $53.6B market (MarketsandMarkets) growing 7.8% CAGR—largest and fastest. Schneider leads; Boyd leverages low-cost scale; nVent is underweight but growing. Critical growth region—prioritize capacity and partners.",
    },
    "geo-1": {
      name: "Europe",
      type: "Geography",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "34%",
          revenue: "~24% of Schneider Electric revenue",
          focus: "Home market strength, LV/MV, buildings, data centers",
          details:
            "Deep installed base and channel density; strong retrofit pull.",
        },
        {
          name: "nVent",
          position: "Strong",
          marketShare: "22%",
          revenue: "~25% of nVent revenue",
          focus: "Enclosures (Schroff), busway, heat-trace",
          details:
            "European roots via Schroff; solid contractor/distributor ties.",
        },
        {
          name: "Boyd Corporation",
          position: "Moderate",
          marketShare: "10%",
          revenue: "~14% of Boyd revenue",
          focus: "Poland plant for cooling; auto/industrial materials",
          details:
            "Select presence; growing liquid cooling and materials for EU OEMs.",
        },
      ],
      keyTakeaways:
        "Europe is a $39.0B market (MarketsandMarkets) at 6.1% CAGR. Schneider leads with incumbency; nVent strong via Schroff/Raychem; Boyd moderate. Mature but retrofit-rich—spec control matters.",
    },
    "geo-2": {
      name: "North America",
      type: "Geography",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "36%",
          revenue: "~36% of Schneider Electric revenue",
          focus: "AI data centers, buildings, utilities; regionalized plants",
          details:
            "Largest region for Schneider; heavy investment in NA capacity and AI programs.",
        },
        {
          name: "nVent",
          position: "Strong",
          marketShare: "28%",
          revenue: "~55% of nVent revenue",
          focus: "Enclosures, busway, heat-trace, fast-ship CDUs",
          details:
            "Core region and profit engine; speed-to-serve and channel depth are advantages.",
        },
        {
          name: "Boyd Corporation",
          position: "Strong",
          marketShare: "16%",
          revenue: "~50% of Boyd revenue",
          focus: "Hyperscaler cooling, A&D/medical materials",
          details:
            "US proximity to hyperscalers; strong service/commissioning for CDUs.",
        },
      ],
      keyTakeaways:
        "North America is $25.0B (MarketsandMarkets) growing 7.2% CAGR. Schneider leads at 36%; nVent strong at 28%—core battlefield. Boyd is significant in AI cooling. High intensity; NA is nVent’s revenue core—DEFEND AT ALL COSTS in enclosures/heat-trace/busway/CDUs.",
    },

    // CUSTOMER SEGMENTS (MarketPosition segments)
    "seg-0": {
      name: "Industrial OEMs & Machine Builders",
      type: "Customer Segment",
      companies: [
        {
          name: "Schneider Electric",
          position: "Strong",
          marketShare: "30%",
          revenue: "~18% of Schneider Electric revenue",
          focus: "PLC/drives + LV gear + enclosures; SI ecosystem",
          details:
            "Combines automation and power; entrenched with OEM standards.",
        },
        {
          name: "nVent",
          position: "Strong",
          marketShare: "22%",
          revenue: "~16% of nVent revenue",
          focus: "Certified enclosures, heat-trace, grounding kits",
          details:
            "Wins with compliance and availability; OEM kits and channel pull.",
        },
        {
          name: "Boyd Corporation",
          position: "Moderate",
          marketShare: "12%",
          revenue: "~12% of Boyd revenue",
          focus: "Thermal/EMI for drives, power modules",
          details:
            "Component-level thermal/EMI attach; sticky BOM positions.",
        },
      ],
      keyTakeaways:
        "Industrial OEMs is a $276.6B market (MarketsandMarkets) at 9.3% CAGR. Schneider and nVent both strong; Boyd component-focused. Large profit pool with steady growth—spec and compliance drive wins.",
    },
    "seg-1": {
      name: "Utilities & Grid Operators",
      type: "Customer Segment",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "38%",
          revenue: "~10% of Schneider Electric revenue",
          focus: "ADMS/DERMS + MV/LV gear, protection",
          details:
            "Top-ranked in microgrid/ADMS; drives multi-year utility programs.",
        },
        {
          name: "nVent",
          position: "Moderate",
          marketShare: "12%",
          revenue: "~10% of nVent revenue",
          focus: "Heat-trace for pipelines, enclosures for substations",
          details:
            "Provides critical protection/heat-trace; relies on project partners.",
        },
      ],
      keyTakeaways:
        "Utilities & grid is $103.4B (MarketsandMarkets) at 10.5% CAGR. Schneider leads via software + gear; nVent is a niche specialist. Moderate intensity; partner-led access is key for nVent.",
    },
    "seg-2": {
      name: "Hyperscale & Colocation",
      type: "Customer Segment",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "30%",
          revenue: "~24% of Schneider Electric revenue",
          focus: "UPS/racks/busway + liquid cooling + DCIM",
          details:
            "Spec control with integrated AI factory stack; deep NA presence.",
        },
        {
          name: "Boyd Corporation",
          position: "Strong",
          marketShare: "26%",
          revenue: "~35% of Boyd revenue",
          focus: "CDUs, cold plates, rack-level loops",
          details:
            "Hyperscaler incumbency with multi-MW CDUs; commissioning services.",
        },
        {
          name: "nVent",
          position: "Strong",
          marketShare: "22%",
          revenue: "~18% of nVent revenue",
          focus: "Racks/busway/CDUs with fast-ship SLAs",
          details:
            "Combines busway/enclosures with emerging CDUs; speed as differentiator.",
        },
      ],
      keyTakeaways:
        "Hyperscale/colo is $79.1B (MarketsandMarkets) at 15.9% CAGR. Schneider leads on full stack; Boyd strong in cooling; nVent strong on racks/busway/CDUs. Hyper-competitive AI-driven space—speed and integration matter.",
    },
    "seg-3": {
      name: "Electrical Contractors & EPCs",
      type: "Customer Segment",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "34%",
          revenue: "~14% of Schneider Electric revenue",
          focus: "Square D/APC channels, EcoXpert certification",
          details:
            "Large partner ecosystem and training create spec lock and loyalty.",
        },
        {
          name: "nVent",
          position: "Strong",
          marketShare: "24%",
          revenue: "~14% of nVent revenue",
          focus: "Fast-ship enclosures/busway, contractor programs",
          details:
            "Wins on availability and support; strong distributor relationships.",
        },
        {
          name: "Boyd Corporation",
          position: "Limited",
          marketShare: "4%",
          revenue: "~2% of Boyd revenue",
          focus: "Component materials; minimal direct contractor sales",
          details:
            "Limited role; mostly materials through OEMs, not direct EPC.",
        },
      ],
      keyTakeaways:
        "Electrical contractors/EPCs is a $73.5B market (MarketsandMarkets) at 6.3% CAGR. Schneider leads via channel scale; nVent is strong on availability; Boyd limited. Spec and channel programs dictate share.",
    },
    "seg-4": {
      name: "Automotive/EV OEMs",
      type: "Customer Segment",
      companies: [
        {
          name: "Schneider Electric",
          position: "Strong",
          marketShare: "26%",
          revenue: "~8% of Schneider Electric revenue",
          focus: "EV charging, MV/LV gear, microgrids for plants",
          details:
            "Provides plant electrification and EVSE infrastructure; growing vertical.",
        },
        {
          name: "Boyd Corporation",
          position: "Strong",
          marketShare: "24%",
          revenue: "~15% of Boyd revenue",
          focus: "Thermal/EMI, gaskets for EV power electronics",
          details:
            "Key supplier of thermal interfaces/seals in EV platforms; strong OEM ties.",
        },
        {
          name: "nVent",
          position: "Limited",
          marketShare: "6%",
          revenue: "~6% of nVent revenue",
          focus: "Enclosures/thermal for EV chargers and power modules",
          details:
            "Selective participation via enclosures and thermal protection; not core.",
        },
      ],
      keyTakeaways:
        "Automotive/EV OEMs is $4.1B (MarketsandMarkets) at 11.1% CAGR. Schneider and Boyd both strong; nVent niche. Growth space driven by EV rollouts—selective focus for nVent on chargers/power modules.",
    },

    // CUSTOMER SEGMENTS (CustomerIntelligence)
    "custseg-0": {
      name: "Hyperscale & Colocation Data Centers",
      type: "Customer Segment",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "32%",
          revenue: "~24% of Schneider Electric revenue",
          focus: "AI-ready UPS/racks/busway, DCIM, liquid cooling",
          details:
            "Sets specs with integrated power/cooling; deep NVIDIA partnerships.",
        },
        {
          name: "Boyd Corporation",
          position: "Strong",
          marketShare: "28%",
          revenue: "~35% of Boyd revenue",
          focus: "CDUs, cold plates, rack emulators for AI",
          details:
            "Hyperscaler incumbent; multi-MW CDUs and commissioning services.",
        },
        {
          name: "nVent",
          position: "Strong",
          marketShare: "24%",
          revenue: "~18% of nVent revenue",
          focus: "Racks/busway/CDUs, fast-ship SLAs",
          details:
            "Competes on speed and integration of enclosures/power/cooling.",
        },
      ],
      keyTakeaways:
        "Hyperscale & colo is $24.9B (MarketsandMarkets) at 7.7% CAGR. Schneider leads on full stack; Boyd strong on cooling; nVent strong on racks/busway/CDUs. AI density accelerates spend—speed and interoperability win.",
    },
    "custseg-1": {
      name: "Commercial & Institutional Buildings",
      type: "Customer Segment",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "34%",
          revenue: "~12% of Schneider Electric revenue",
          focus: "BMS + LV gear, energy optimization",
          details:
            "EcoStruxure-driven retrofits; strong channel in NA/EU.",
        },
        {
          name: "nVent",
          position: "Growing",
          marketShare: "14%",
          revenue: "~18% of nVent revenue",
          focus: "Enclosures, busway, heat-trace for campuses/hospitals",
          details:
            "Wins on availability and certified protection products.",
        },
        {
          name: "Boyd Corporation",
          position: "Limited",
          marketShare: "4%",
          revenue: "~3% of Boyd revenue",
          focus: "Seals/EMI for building electronics",
          details:
            "Minimal share; component-level only.",
        },
      ],
      keyTakeaways:
        "Commercial/institutional buildings is $86.8B (MarketsandMarkets) at ~13.4% CAGR. Schneider leads; nVent growing via enclosures/busway; Boyd niche. Large retrofit tailwind—spec control critical.",
    },
    "custseg-2": {
      name: "Industrial Automation & Control",
      type: "Customer Segment",
      companies: [
        {
          name: "Schneider Electric",
          position: "Strong",
          marketShare: "28%",
          revenue: "~18% of Schneider Electric revenue",
          focus: "PLC/drives + LV gear, software-defined automation",
          details:
            "Strong SI ecosystem; pairs automation with power distribution.",
        },
        {
          name: "nVent",
          position: "Strong",
          marketShare: "22%",
          revenue: "~16% of nVent revenue",
          focus: "Certified enclosures, thermal, grounding",
          details:
            "Trusted for compliance and protection; OEM kits drive pull.",
        },
        {
          name: "Boyd Corporation",
          position: "Moderate",
          marketShare: "10%",
          revenue: "~12% of Boyd revenue",
          focus: "Thermal/EMI for control electronics",
          details:
            "Thermal assemblies for drives/controllers; sticky BOMs.",
        },
      ],
      keyTakeaways:
        "Industrial automation is $276.6B (MarketsandMarkets) at 9.3% CAGR. Schneider and nVent both strong; Boyd component-focused. Large, steady market—compliance and availability matter.",
    },
    "custseg-3": {
      name: "Electrical Utilities & Microgrids",
      type: "Customer Segment",
      companies: [
        {
          name: "Schneider Electric",
          position: "Leader",
          marketShare: "38%",
          revenue: "~10% of Schneider Electric revenue",
          focus: "ADMS/DERMS + MV/LV gear, microgrids",
          details:
            "Top-ranked grid software; bundles gear/services for resilience.",
        },
        {
          name: "nVent",
          position: "Moderate",
          marketShare: "12%",
          revenue: "~10% of nVent revenue",
          focus: "Heat-trace, enclosures, grounding for utilities",
          details:
            "Protection-focused; relies on partner-led delivery.",
        },
        {
          name: "Boyd Corporation",
          position: "Limited",
          marketShare: "3%",
          revenue: "~2% of Boyd revenue",
          focus: "Thermal/EMI materials for utility electronics",
          details:
            "Minor role; component-level supply.",
        },
      ],
      keyTakeaways:
        "Electrical utilities & microgrids is $30.8B (MarketsandMarkets) at ~10.5% CAGR. Schneider leads with software + MV gear; nVent is a niche specialist; Boyd minimal. Project-driven, partner-heavy segment.",
    },
    "custseg-4": {
      name: "eMobility Power Electronics Thermal",
      type: "Customer Segment",
      companies: [
        {
          name: "Boyd Corporation",
          position: "Leader",
          marketShare: "32%",
          revenue: "~15% of Boyd revenue",
          focus: "Thermal interfaces, gaskets for EV inverters/batteries",
          details:
            "Strong EV materials and thermal portfolio; IATF programs across regions.",
        },
        {
          name: "Schneider Electric",
          position: "Strong",
          marketShare: "24%",
          revenue: "~8% of Schneider Electric revenue",
          focus: "EVlink chargers, plant power, microgrids",
          details:
            "Grows through EVSE and plant electrification; leverages utility ties.",
        },
        {
          name: "nVent",
          position: "Moderate",
          marketShare: "10%",
          revenue: "~6% of nVent revenue",
          focus: "Enclosures/thermal protection for EVSE and power modules",
          details:
            "Selective play via protective enclosures and thermal solutions.",
        },
      ],
      keyTakeaways:
        "eMobility power electronics thermal is $12.8B (MarketsandMarkets) at 18.4% CAGR. Boyd leads with thermal/EMI; Schneider strong via EVSE; nVent moderate via protection. Fast-growing adjacency—partnerships key.",
    },
  };

  const marketData = {
    // TECHNOLOGIES
    "tech-0": {
      size: "$73.5B",
      year: "2024",
      cagr: "6.3%",
      period: "2024-2030",
    },
    "tech-1": { size: "$7.7B", year: "2024", cagr: "6.8%", period: "2024-2030" },
    "tech-2": { size: "$7.4B", year: "2024", cagr: "5.6%", period: "2024-2030" },
    "tech-3": { size: "$4.8B", year: "2024", cagr: "24.7%", period: "2024-2030" },
    "tech-4": { size: "$3.4B", year: "2024", cagr: "5.2%", period: "2024-2030" },

    // APPLICATIONS
    "app-0": { size: "$276.6B", year: "2024", cagr: "9.3%", period: "2024-2030" },
    "app-1": { size: "$121.9B", year: "2024", cagr: "21.5%", period: "2024-2030" },
    "app-2": { size: "$103.4B", year: "2024", cagr: "10.5%", period: "2024-2030" },
    "app-3": { size: "$101.7B", year: "2024", cagr: "13.4%", period: "2024-2030" },
    "app-4": { size: "$41.1B", year: "2024", cagr: "11.3%", period: "2024-2030" },

    // GEOGRAPHIES
    "geo-0": { size: "$53.6B", year: "2024", cagr: "7.8%", period: "2024-2030" },
    "geo-1": { size: "$39.0B", year: "2024", cagr: "6.1%", period: "2024-2030" },
    "geo-2": { size: "$25.0B", year: "2024", cagr: "7.2%", period: "2024-2030" },

    // SEGMENTS (MarketPosition)
    "seg-0": { size: "$276.6B", year: "2024", cagr: "9.3%", period: "2024-2030" },
    "seg-1": { size: "$103.4B", year: "2024", cagr: "10.5%", period: "2024-2030" },
    "seg-2": { size: "$79.1B", year: "2024", cagr: "15.9%", period: "2024-2030" },
    "seg-3": { size: "$73.5B", year: "2024", cagr: "6.3%", period: "2024-2030" },
    "seg-4": { size: "$4.1B", year: "2024", cagr: "11.1%", period: "2024-2030" },

    // CUSTOMERINTELLIGENCE segments
    "custseg-0": { size: "$24.9B", year: "2024", cagr: "7.7%", period: "2024-2030" },
    "custseg-1": { size: "$86.8B", year: "2024", cagr: "13.4%", period: "2024-2030" },
    "custseg-2": { size: "$276.6B", year: "2024", cagr: "9.3%", period: "2024-2030" },
    "custseg-3": { size: "$30.8B", year: "2024", cagr: "10.5%", period: "2024-2030" },
    "custseg-4": { size: "$12.8B", year: "2024", cagr: "18.4%", period: "2024-2030" },
  };

  const renderPositionDots = (position, companyName) => {
    const dotsCount =
      position === "Leader" || position === "Dominant"
        ? 5
        : position === "Strong"
        ? 4
        : position === "Growing" || position === "Moderate"
        ? 3
        : position === "Limited"
        ? 2
        : position === "None"
        ? 0
        : 1;

    const companyColors = {
      Henkel: "danger",
      "H.B. Fuller": "primary",
      Bostik: "info",
      Tailored: "secondary",
    };

    const color = companyColors[companyName] || "secondary";

    return (
      <div
        className="d-flex gap-1 align-items-center"
        title={`${companyName}: ${position}`}
      >
        {[...Array(5)].map((_, idx) => (
          <div
            key={idx}
            className={`rounded-circle ${
              idx < dotsCount
                ? `bg-${color}`
                : "bg-light border border-2 border-secondary"
            }`}
            style={{ width: "12px", height: "12px" }}
          ></div>
        ))}
      </div>
    );
  };

  if (!selectedDetailModal) return null;

  const modalData = detailedCompetitiveData[selectedDetailModal];
  if (!modalData) return null;

  return (
    <Modal
      show={!!selectedDetailModal}
      onHide={() => setSelectedDetailModal(null)}
      size="xl"
      centered
      scrollable
    >
      <style>{`
        .modal-header-gradient {
          font-weight: 600;
          font-size: 14px;
          line-height: 17.5px;
          color: #1e1c25;
          margin-bottom: 3px;
        }
        .market-info-bar {
          background: #f7f9ff;
          padding: 1.5rem;
          border-bottom: 2px solid #d0deff;
        }
        .market-stat {
          padding: 12px;
          background: #fff;
          border-radius: 8px;
          font-size:14px;
          border-left: 4px solid #6610f2;
        }
        .tab-button {
          padding: 12px 16px;
          border-radius: 0.5rem;
          font-weight: 500;
          font-size: 13px;
          transition: all 0.3s;
          border: none;
          cursor: pointer;
        }
        .tab-button-active {
          background: #4E6BCA;
          color: #fff;
          font-weight: 500;
          box-shadow: 0 2px 8px rgba(102,16,242,0.4);
        }
        .tab-button-inactive {
          background: #fff;
          color: #6c757d;
          border: 1px solid #dee2e6;
        }
        .tab-button-inactive:hover {
          background: #fff;
          border-color: #4E6BCA;
          color: #fff;
        }
        .company-row-bostik {
          background: #d1ecf1 !important;
        }
        .company-row-henkel {
          background: #f8d7da !important;
        }
        .company-row-hbfuller {
          background: #cfe2ff !important;
        }
        .company-row-tailored {
          background: #e2e3e5 !important;
        }
        .company-row td {
          padding: 12px;
          position: relative;
          border-bottom: 1px solid #e2e8f0;
          border-right: 1px solid #e2e8f0;
          white-space: normal;
          overflow: hidden;
          word-break: break-word;
          vertical-align: middle;
          font-weight: unset;
          font-size: 12px;
        }
        .takeaway-box {
          background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
          border-left: 5px solid #ffa726;
          border-radius: 8px;
          padding: 12px 16px;
        }
        .modal-content {
          border: none;
          border-radius: 1rem;
          overflow: hidden;
        }
        .close-button {
          background: #fff;
          border: none;
          border-radius: 0.375rem;
          padding: 0.5rem;
          width: 2.5rem;
          height: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
        }
        .close-button:hover {
          background: #f8f9fa;
          transform: scale(1.1);
        }
        .modal-title-new{
          font-size: 16px;
          font-weight: 600 !important;
        }
      `}</style>

      <Modal.Header className="modal-header-gradient border-0">
        <div className="d-flex justify-content-between align-items-start w-100">
          <div>
            <div className="text-sm opacity-90 mb-1">
              {modalData.type} Deep Dive
            </div>
            <Modal.Title className="text-2xl font-bold text-white modal-title-new d-inline">
              <span className="modal-title-new">{modalData.name}</span>
              <a
                href="https://www.marketsandmarkets.com/knowledgestore.asp"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 bg-blue-600 text-sm font-semibold rounded-lg hover:bg-blue-700 transition flex items-center gap-2"
              >
                <span>📊</span>View Market Report
              </a>
            </Modal.Title>
          </div>
          <button
            onClick={() => setSelectedDetailModal(null)}
            className="close-button"
          >
            <X size={20} color="#6610f2" />
          </button>
        </div>
      </Modal.Header>

      {marketData[selectedDetailModal] && (
        <div className="market-info-bar">
          <div className="row g-3">
            <div className="col-md-6">
              <div className="market-stat">
                <div
                  className="small text-uppercase mb-2"
                  style={{ color: "#6610f2", letterSpacing: "0.5px" }}
                >
                  MARKET SIZE
                </div>
                <div
                  className="h2 fw-bold mb-1"
                  style={{ color: "#1e293b", fontSize: "16px" }}
                >
                  {marketData[selectedDetailModal].size}
                </div>
                <div className="small text-muted">
                  Global ({marketData[selectedDetailModal].year})
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="market-stat">
                <div
                  className="small text-uppercase mb-2"
                  style={{ color: "#6610f2", letterSpacing: "0.5px" }}
                >
                  GROWTH RATE
                </div>
                <div
                  className="h2 fw-bold mb-1 text-success"
                  style={{ fontSize: "16px" }}
                >
                  {marketData[selectedDetailModal].cagr}
                </div>
                <div className="small text-muted">
                  CAGR {marketData[selectedDetailModal].period}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="bg-light p-3">
        <div className="d-flex gap-2">
          {[
            { id: "market_share", label: "Market Position" },
            { id: "revenue", label: "Revenue Contribution" },
            {
              id: "focus",
              label:
                modalData.type === "Customer Segment"
                  ? "Key Pain Points"
                  : "Company Focus",
            },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setDetailModalView(tab.id)}
              className={`tab-button ${
                detailModalView === tab.id
                  ? "tab-button-active"
                  : "tab-button-inactive"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <Modal.Body className="p-0">
        <div className="table-responsive">
          <table className="custom-resizable-table p-3">
            <thead
              style={{
                background: "#f8f9fa",
                borderBottom: "2px solid #dee2e6",
              }}
            >
              <tr className="custom-resizable-table-header">
                <th className="fw-bold py-3 px-4" style={{ width: "15%" }}>
                  <div className="custom-resizable-table-th-content">
                    Company
                  </div>
                </th>
                <th className="fw-bold py-3 px-4" style={{ width: "20%" }}>
                  <div className="custom-resizable-table-th-content">
                    {" "}
                    Market Position
                  </div>
                </th>
                {detailModalView === "market_share" && (
                  <th className="fw-bold py-3 px-4" style={{ width: "15%" }}>
                    <div className="custom-resizable-table-th-content">
                      Market Share
                    </div>
                  </th>
                )}
                {detailModalView === "revenue" && (
                  <th className="fw-bold py-3 px-4" style={{ width: "20%" }}>
                    <div className="custom-resizable-table-th-content">
                      {" "}
                      Revenue Contribution
                    </div>
                  </th>
                )}
                {detailModalView === "focus" && (
                  <th className="fw-bold py-3 px-4" style={{ width: "25%" }}>
                    {modalData.type === "Customer Segment"
                      ? "Key Pain Points"
                      : "Strategic Focus"}
                  </th>
                )}
                <th className="fw-bold py-3 px-4">
                  <div className="custom-resizable-table-th-content">
                    Key Details
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {modalData.companies.map((company, idx) => {
                const companyRowClass =
                  company.name === "Henkel"
                    ? "company-row-henkel"
                    : company.name === "H.B. Fuller"
                    ? "company-row-hbfuller"
                    : company.name === "Bostik"
                    ? "company-row-bostik"
                    : "company-row-tailored";

                return (
                  <tr key={idx} className={`company-row ${companyRowClass}`}>
                    <td className="px-4 fw-bold">{company.name}</td>
                    <td className="px-4">
                      {renderPositionDots(company.position, company.name)}
                    </td>
                    {detailModalView === "market_share" && (
                      <td className="px-4">{company.marketShare}</td>
                    )}
                    {detailModalView === "revenue" && (
                      <td className="px-4">{company.revenue}</td>
                    )}
                    {detailModalView === "focus" && (
                      <td className="px-4">{company.focus}</td>
                    )}
                    <td className="px-4 text-muted">{company.details}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="p-4">
          <div className="takeaway-box">
            <div className="d-flex gap-3 align-items-start">
              <span style={{ fontSize: "1rem" }}>💡</span>
              <div className="flex-grow-1">
                <div
                  className="fw-bold mb-2"
                  style={{ fontSize: "14px", color: "#1e293b" }}
                >
                  Key Takeaways
                </div>
                <p
                  className="mb-0"
                  style={{
                    lineHeight: "1.6",
                    color: "#475569",
                    fontSize: "13px",
                  }}
                >
                  {modalData.keyTakeaways}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DetailModal;